import type { UserTag, UserTagServer } from '@/types/userTags'

export const normalizeUserTag = (tag: UserTagServer): UserTag => ({
  id: tag.id,
  name: tag.name,
  usersCount: tag.users_count,
  totalFollowers: tag.total_followers,
})
